import Colors from 'components/Colors.js';
const colors = new Colors();

export default superclass => class extends superclass  {
    get color() {
        if (this._color) {
            return this._color;
        }
        return colors.getColorForTrack(this);
    }

    set color(x) {
        this._color = x;
    }
}
